import { render } from "./AbtproView.vue?vue&type=template&id=6fd0a4d6"
import script from "./AbtproView.vue?vue&type=script&lang=js"
export * from "./AbtproView.vue?vue&type=script&lang=js"

import "./AbtproView.vue?vue&type=style&index=0&id=6fd0a4d6&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__